import React, { useEffect, useState } from "react";
import info from "../../assets/icons/i.svg";
import listForm from "../../assets/icons/form-icon.svg";
import telesale from "../../assets/icons/Telesale-icon.svg";
import finishForm from "../../assets/icons/finish-form-icon.svg";
import App from "../../assets/icons/APp-icon.svg";
import elipsePurple from "../../assets/icons/ellipse-purple.svg";
import elipseGreen from "../../assets/icons/ellipse-green.svg";
import elipsePink from "../../assets/icons/ellipse-pink.svg";
import elipseBlue from "../../assets/icons/ellipse-blue.svg";
import polygon1 from "../../assets/polygons/Polygon 1 (Stroke).svg";
import polygon2 from "../../assets/polygons/Polygon 2 (Stroke).svg";
import polygon3 from "../../assets/polygons/Polygon 3 (Stroke).svg";
import polygon4 from "../../assets/polygons/Polygon 4 (Stroke).svg";
import polygon5 from "../../assets/polygons/Polygon 5 (Stroke).svg";
import polygon6 from "../../assets/polygons/Polygon 6 (Stroke).svg";
import polygon7 from "../../assets/polygons/Polygon 7 (Stroke).svg";
import polygon8 from "../../assets/polygons/Polygon 8 (Stroke).svg";
import donghoVay from "../../assets/icons/dongho-vay.svg";
import loanUserIcon from "../../assets/icons/uil_user.svg";
import phoneIcon from "../../assets/icons/solar_phone-broken.svg";
import idCardIcon from "../../assets/icons/id-card-outline-sharp.svg";
import arrowUpWhite from "../../assets/icons/tabler_arrow-up-white.svg";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { dangKyVay } from "../../services/dangKyVayService";

function LoanForm({ loan, loanMonth, setLoan, setLoanMonth }) {
  const interestRate = 0.18;
  const days = loanMonth * 30;
  const total = loan + loan * interestRate * (loanMonth / 12);
  const daily = Math.round(total / days);

  const minLoan = 3000000;
  const maxLoan = 300000000;
  const minLoanMonth = 6;
  const maxLoanMonth = 24;

  const amountPercent = Math.round(
    ((loan - minLoan) / (maxLoan - minLoan)) * 100
  );
  const loanMonthPercent = Math.round(
    ((loanMonth - minLoanMonth) / (maxLoanMonth - minLoanMonth)) * 100
  );

  const formatCurrency = (value) =>
    new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(value);

  return (
    <form className="vayonline-loan-form">
      <div className="vayonline-form-section">
        <label className="vayonline-form-label">
          <span
            style={{
              color: "#344054",
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "700",
              wordWrap: "break-word",
            }}
          >
            Số tiền bạn cần{" "}
          </span>
          <span
            style={{
              color: "#57C4AD",
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "700",
              wordWrap: "break-word",
            }}
          >
            vay**
          </span>
        </label>
        <div className="vayonline-amount-display">{formatCurrency(loan)}</div>
        <div className="vayonline-slider-container">
          <input
            type="range"
            min={minLoan}
            max={maxLoan}
            step={1000000}
            value={loan}
            onChange={(e) => setLoan(Number(e.target.value))}
            className="vayonline-slider-bar"
            style={{
              background: `linear-gradient(to right, #2e74d4 0%, #2e74d4 ${amountPercent}%, #E5EDF7 ${amountPercent}%, #E5EDF7 100%)`,
            }}
          />
          <div className="vayonline-slider-track">
            <span className="vayonline-slider-marker">3.000.000 đ</span>
            <span className="vayonline-slider-marker">300.000.000 đ</span>
          </div>
        </div>
      </div>

      <div className="vayonline-form-section">
        <label className="vayonline-form-label">
          <span
            style={{
              color: "#344054",
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "700",
              wordWrap: "break-word",
            }}
          >
            Kỳ hạn vay
          </span>
        </label>
        <div className="vayonline-term-display">{loanMonth} tháng</div>

        <div className="vayonline-slider-container">
          <input
            type="range"
            min={minLoanMonth}
            max={maxLoanMonth}
            step={1}
            value={loanMonth}
            onChange={(e) => setLoanMonth(Number(e.target.value))}
            className="vayonline-slider-bar"
            style={{
              background: `linear-gradient(to right, #2e74d4 0%, #2e74d4 ${loanMonthPercent}%, #E5EDF7 ${loanMonthPercent}%, #E5EDF7 100%)`,
            }}
          />
          <div className="vayonline-slider-track">
            <span className="vayonline-slider-marker">6 tháng</span>
            <span className="vayonline-slider-marker">24 tháng</span>
          </div>
        </div>
      </div>

      <div className="vayonline-form-border"></div>

      <div className="vayonline-daily-installment">
        <span className="vayonline-installment-label">
          Dự kiến tiền góp hàng ngày
        </span>
        <div className="vayonline-installment-amount-gradient">
          {formatCurrency(daily)}
        </div>
        <div className="vayonline-installment-note">
          *Giá trị chỉ mang tính tham khảo.
          <br /> Khoản vay được xét duyệt sẽ tùy thuộc vào điều kiện và hồ sơ cụ
          thể của từng trường hợp.
        </div>
      </div>
    </form>
  );
}

function UserInfoForm({ onSubmit }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [nationalId, setIdNumber] = useState("");
  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!name.trim() || name.trim().length < 2)
      newErrors.name = "Họ và tên phải có ít nhất 2 ký tự.";
    if (!/^[0-9]{10}$/.test(phone))
      newErrors.phone = "Số điện thoại phải gồm 10 chữ số.";
    if (!/^[0-9]{9,12}$/.test(nationalId))
      newErrors.nationalId = "Số CCCD/CMND phải có 9 hoặc 12 chữ số.";
    if (!consent)
      newErrors.consent = "Bạn cần đồng ý điều khoản trước khi tiếp tục.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  function handleSubmit(event) {
    event.preventDefault();
    if (!validate()) return;
    onSubmit({ name, phone, nationalId });
    setName("");
    setPhone("");
    setIdNumber("");
    setConsent(false);
  }

  return (
    <form className="loan-info-form" onSubmit={handleSubmit}>
      <div className="loan-info-title">Nhập thông tin đăng ký vay</div>

      <label className="loan-input-label" htmlFor="name">
        Họ và tên <span className="required">*</span>
      </label>
      <div className="loan-input-group">
        <span className="loan-input-icon">
          <img src={loanUserIcon} alt="loan-user" />
        </span>
        <input
          id="name"
          className="loan-input"
          placeholder="Nhập họ và tên của bạn"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      {errors.name && (
        <div className="text-danger small mt-1">{errors.name}</div>
      )}

      <label className="loan-input-label" htmlFor="phone">
        Số điện thoại <span className="required">*</span>
      </label>
      <div className="loan-input-group">
        <span className="loan-input-icon">
          <img src={phoneIcon} alt="loan-phone" />
        </span>
        <input
          id="phone"
          className="loan-input"
          placeholder="Nhập số điện thoại"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      {errors.phone && (
        <div className="text-danger small mt-1">{errors.phone}</div>
      )}

      <label className="loan-input-label" htmlFor="nationalId">
        Số CCCD/CMND <span className="required">*</span>
      </label>
      <div className="loan-input-group">
        <span className="loan-input-icon">
          <img src={idCardIcon} alt="loan-id" />
        </span>
        <input
          id="nationalId"
          className="loan-input"
          placeholder="Nhập số CCCD/CMND"
          value={nationalId}
          onChange={(e) => setIdNumber(e.target.value)}
        />
      </div>
      {errors.nationalId && (
        <div className="text-danger small mt-1">{errors.nationalId}</div>
      )}

      <label className="loan-checkbox">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
        />
        <span>
          Bằng việc tiếp tục, tôi cho phép Blue-zone liên hệ với tôi và đồng ý
          để Blue-zone thu thập, phân tích dữ liệu cá nhân
        </span>
      </label>
      {errors.consent && (
        <div className="text-danger small mt-1">{errors.consent}</div>
      )}

      <div className="btn-get-money">
        <button
          className="loan-submit-button"
          type="submit"
          disabled={!consent}
        >
          NHẬN TIỀN NGAY{" "}
          <img
            src={arrowUpWhite}
            alt="Arrow up white"
            className="arrow-up-white"
          />
        </button>
      </div>
      <div className="loan-safe-note">
        Thông tin của bạn được bảo mật tuyệt đối
      </div>
    </form>
  );
}

const DangKyVay = () => {
  const location = useLocation();
  const { loan: initialLoan, loanMonth: initialLoanMonth } =
    location.state || {};
  const [loan, setLoan] = useState(initialLoan || 3000000);
  const [loanMonth, setLoanMonth] = useState(initialLoanMonth || 6);

  const [source, setSource] = useState("");
  const [aff_sid, setAff_sid] = useState("");
  const [utm_source, setUtm_source] = useState("");

  useEffect(() => {
    const params = window.location.search;

    let getParams = new URLSearchParams(document.location.search);
    let aff_sid = getParams.get("aff_sid");
    let utm_source = getParams.get("utm_source");

    setSource(params);
    setAff_sid(aff_sid);
    setUtm_source(utm_source);
  }, []);

  const headers = { "Content-Type": "application/json" };

  const handleUserInfoSubmit = async (userInfo) => {
    const data = {
      loan,
      loanMonth,
      source,
      aff_sid,
      utm_source,
      website: window.location.href,
      ...userInfo,
    };

    dangKyVay(headers, data)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Đăng ký thành công! Chúng tôi sẽ liên hệ sớm.", {
            position: "top-right",
            autoClose: 3000,
          });
          // reset form
          setLoan(3000000);
          setLoanMonth(6);
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại!",
          { position: "top-right", autoClose: 3000 }
        );
      });
  };

  return (
    <div className="loan-page-online">
      <section className="d-flex register-online-section">
        <div className="vayonline-loan-form-card-step container">
          <div className="vayonline-form-title-step">
            Nhập thông tin khoản vay của bạn
          </div>
          <div className="vayonline-form-subtitle-step">
            Hoàn thành thông tin bên dưới để nhận khoản vay với lãi suất ưu đãi
            và thủ tục đơn giản.
          </div>
          <div className="vayonline-form-highlight">
            <div className="text-highlight">
              <img src={donghoVay} alt="Đồng hồ vay" className="dongho-vay" />
              Quy trình phê duyệt nhanh chóng
            </div>
          </div>
          <div className="vayonline-two-col">
            <LoanForm
              loan={loan}
              loanMonth={loanMonth}
              setLoan={setLoan}
              setLoanMonth={setLoanMonth}
            />
            <div className="vayonline-col-divider" />
            <UserInfoForm onSubmit={handleUserInfoSubmit} />
          </div>
        </div>
      </section>
      <ToastContainer />

      <section className="works-section">
        <div className="container works-card-step">
          <h2 className="works-title">Quy trình đăng ký vay đơn giản</h2>
          <p className="works-description">
            Thủ tục nhanh gọn, chỉ với 4 bước đơn giản để nhận khoản tiền giải
            ngân sau 15 phút
          </p>
          <div className="works-content">
            <div className="work-one">
              <img src={listForm} alt="listForm" className="listForm" />
              <img src={polygon1} alt="polygon1" className="polygon-1" />
              <div className="line-1"></div>
              <div className="elipse-purple">
                <img src={elipsePurple} alt="" />
              </div>
              <span className="number-one">1</span>
              <span className="text-work-one">
                Điền thông tin
                <br /> đăng ký vay
              </span>
            </div>

            <div className="work-two">
              <img src={telesale} alt="telesale" className="telesale" />
              <img src={polygon2} alt="polygon2" className="polygon-2" />
              <div className="line-2"></div>
              <div className="elipse-green">
                <img src={elipseGreen} alt="" />
              </div>
              <span className="number-two">2</span>
              <span className="text-work-two">
                Nhân viên chăm sóc khách hàng sẽ liên lạc với bạn để tư vấn &
                hướng dẫn chuẩn bị các thủ tục đơn giản, nhanh gọn
              </span>
            </div>

            <div className="work-three">
              <img src={finishForm} alt="finishForm" className="finishForm" />
              <img src={polygon3} alt="polygon3" className="polygon-3" />
              <div className="line-3"></div>
              <div className="elipse-pink">
                <img src={elipsePink} alt="" />
              </div>
              <span className="number-three">3</span>
              <span className="text-work-three">
                Bạn nhận luôn kết quả phê duyệt hoặc cập nhật thông qua Zalo OA
                hoặc website của Blue-zone để hoàn tất thủ tục & ký hồ sơ chỉ
                trong vòng 15 phút
              </span>
            </div>

            <div className="work-four">
              <img src={App} alt="APp" className="app" />
              <img src={polygon4} alt="polygon4" className="polygon-4" />
              <div className="line-4"></div>
              <div className="elipse-blue">
                <img src={elipseBlue} alt="" />
              </div>
              <span className="number-four">4</span>
              <span className="text-work-four">
                <ul>
                  <li>Nhận tiền giải ngân thông qua phương thức đã đăng ký</li>
                </ul>
              </span>
            </div>

            <img src={polygon5} alt="polygon5" className="polygon-5" />
            <img src={polygon6} alt="polygon6" className="polygon-6" />
            <img src={polygon7} alt="polygon7" className="polygon-7" />
            <img src={polygon8} alt="polygon8" className="polygon-8" />
            <div className="line"></div>
          </div>
        </div>
      </section>

      <div className="d-flex justify-content-center">
        <div
          className="info-work d-flex align-items-center rounded-3 py-3 px-3 gap-3 mb-0 w-100"
          role="alert"
        >
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-50 dots-white">
            <img src={info} alt="info" />
          </div>
          <div className="d-flex flex-column">
            <div className="fw-semibold">Lưu ý quan trọng</div>
            <div className="small mb-0">
              Quá trình giải ngân có thể nhanh hơn tùy thuộc vào tình trạng hồ
              sơ của bạn. Nhân viên tư vấn sẽ hỗ trợ bạn trong suốt quá trình.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DangKyVay;
